import axios from 'axios';
import { clear } from './tabs.js';

const noticiationCard = document.querySelector('.notification-card');
const endPoint = 'actions/e7project/newsletter';

const submitForm = (form) => {
    const button = form.querySelector('button');
    button.classList.add('btn--disabled');

    const alwaysExpectedData = ['contactType', 'firstName', 'lastName', 'email', 'state'];
    const specificExpectedData = {
        Student: ['studentType', 'yearFinishing', 'interestedInCEWork'],
        Business: ['company', 'position'],
        Consumer: ['interestedInSolar', 'interestedInBatteryStorage'],
        'Public newsletter subscriber': ['company'],
    };

    const inputs = Array.from(form);
    const contactTypeEl = inputs.find(el => el.name === 'contactType');
    const contactType = contactTypeEl ? contactTypeEl.value : '';
    if (specificExpectedData[contactType] === undefined) {
        // we reached an unknown contact type, this shouldn't happen in normal usage
        button.classList.remove('btn--disabled');
        if (!document.querySelector('.error')) {
            form.insertAdjacentHTML('beforebegin', '<p class="error semi text--orange">Something went wrong. Please try again later</p>');
        }

        return;
    }

    // grab basic expected data based on contact type
    const expectedData = alwaysExpectedData.concat(specificExpectedData[contactType]);
    const data = Object.fromEntries(Array.from(form).filter(
        el => expectedData.indexOf(el.name) !== -1
            && (el.type !== 'radio' || el.checked)
            && el.value
    ).map(el => [el.name, el.value]));

    // grab subscription options and map them to correct keys
    const checkboxes = Array.from(form.querySelectorAll('.subscriptionOptions input[type="checkbox"][name]'));
    const subscriptionOptions = Object.fromEntries(checkboxes.filter(el => el.checked).map((el) => [{
            News: 'news',
            Careers: 'careers',
            Events: 'events',
            'Women in Renewables': 'womenInRenewables',
            'Information for consumers': 'consumerInformation',
            'Clean energy news': 'news',
        }[el.getAttribute('value')], true]
    ));

    data.subscriptionOptions = {
        ...{
            "events": false,
            "news": false,
            "womenInRenewables": false,
            "careers": false,
            "consumerInformation": false,
            "dailymediawrap": false,
            "weeklymemberupdate": false
        },
        ...subscriptionOptions
    };

    data.interestedInCEWork = data.studentType === 'University / TAFE'
        ? (data.interestedInCEWork === 'Yes' ? true : false)
        : undefined;

    // map solar to expected SF values
    if (data.interestedInSolar) {
        data.interestedInSolar = {
            'I have installed solar': 'Solar installed',
            'I would like to get solar installed soon': 'Interested now',
            'I would like to get solar installed in the future': 'Interested in future',
        }[data.interestedInSolar];
    }

    // map battery storage to expected SF values
    if (data.interestedInBatteryStorage) {
        data.interestedInBatteryStorage = {
            'I have installed battery storage': 'Battery storage installed',
            'I would like to get battery storage installed soon': 'Interested now',
            'I would like to get battery storage installed in the future': 'Interested in future',
        }[data.interestedInBatteryStorage];
    }

    axios({
        method: 'post',
        url: endPoint,
        data,
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(() => {
        button.classList.remove('btn--disabled');
        clear(document.querySelector('.subscribe'));
        noticiationCard.classList.remove('hide');
        scrollTo({ top: noticiationCard.offsetTop });
    }).catch(() => {
        button.classList.remove('btn--disabled');
        if (!document.querySelector('.error')) {
            form.insertAdjacentHTML('beforebegin', '<p class="error semi text--orange">Something went wrong. Please try again later</p>');
        }
    });
};


export default (() => {
    document.querySelectorAll('.js-subscribe').forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            submitForm(form);
        });

        // Student conditional field
        const studentTypeRadioGroup = form.querySelectorAll('input[name=studentType]');
        const interestedInCEWork = form.querySelector('.js-conditional-interestedInCEWork');
        studentTypeRadioGroup.forEach((radio) => {
            radio.addEventListener('change', () => {
                if (radio.value === 'University / TAFE' && radio.checked) {
                    interestedInCEWork.style.display = null;
                } else {
                    interestedInCEWork.style.display = 'none';
                }
            }) ;
        });
    });
})();
